import type { AgentManifest } from '@indipia/shared';
import { routes } from './src/routes';

export const manifest: AgentManifest = {
  agentId: 'billing',
  routes,
  menuItems: [
    {
      id: 'billing',
      label: '구독결제',
      icon: 'credit-card',
      path: '/agents/billing',
      category: 'common',
      order: 90,
    },
  ],
  // 구독·결제 관리는 사장님만 가능(사용자 결정, 2026-09-08) — 실제 접근 차단은 routes.ts의
  // withOwnerGuard()가 담당한다(이 배열은 shell-web 어디서도 소비되지 않는 문서용 값,
  // packages/shared/src/agents/contract.ts는 유효성 검증만 함).
  permissions: ['OWNER'],
};
